document.addEventListener('DOMContentLoaded', function() {
	var sections = document.querySelectorAll('.announcement-splide.splide');
	sections.forEach(function(el) {
		var type = el.getAttribute('data-type') || 'loop';
		var autoplay = (el.getAttribute('data-autoplay') || 'true') === 'true';
		var interval = parseInt(el.getAttribute('data-interval') || '3000', 10);
		var speed = parseInt(el.getAttribute('data-speed') || '400', 10);
		var arrows = (el.getAttribute('data-arrows') || 'false') === 'true';

		new Splide(el, {
			type: type,
			autoplay: autoplay,
			interval: interval,
			speed: speed,
			arrows: arrows,
			pagination: false,
			rewind: false,
			perPage: 1,
			perMove: 1
		}).mount();
	});
});


